import { SvgIcon, SxProps, Theme } from '@mui/material';
import { FC } from 'react';

interface Props {
	sx?: SxProps<Theme>;
}

export const FilledStoreIcon: FC<Props> = (props) => (
	<SvgIcon {...props} viewBox="0 0 348.97 316.25">
		<path d="M313.306,87.24h-7.961V59.974c0-4.336-1.727-8.494-4.8-11.554C269.735,17.59,221.705,0,174.485,0  c-47.22,0-95.25,17.59-126.06,48.42h0c-3.073,3.06-4.8,7.218-4.8,11.554V87.24H35.01c-19.333,0-35.005,15.672-35.005,35.005V316.25  h127.722c-0.191-0.944-0.293-1.921-0.293-2.921v-87.811c0-8.096,6.563-14.66,14.66-14.66h64.781c8.096,0,14.66,6.564,14.66,14.66  v87.811c0,1.001-0.102,1.977-0.293,2.921h127.722V122.898C348.965,103.205,333,87.24,313.306,87.24z M217.945,129.495h-86.919  c-6.111,0-11.065-4.954-11.065-11.065c0-6.111,4.954-11.065,11.065-11.065h86.919c6.111,0,11.065,4.954,11.065,11.065  C229.01,124.541,224.056,129.495,217.945,129.495z" />
	</SvgIcon>
);
